import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector
} from '@ngrx/store';

import * as OccupationCardsState from './occupation-cards.state';
import {
  IOccupationCard,
  OccupationCategory
} from '@cpd-app/core-module/models';

// RETRIEVE OCCUPATION CARDS SLICE OF STATE
export const selectOccupationCardsState =
  createFeatureSelector<OccupationCardsState.OccupationCardsState>(
    OccupationCardsState.occupationCardsFeatureKey
  );

// RETRIEVE OCCUPATION CARDS
export const getOccupationCategoryArray: MemoizedSelector<
  object,
  OccupationCategory[]
> = createSelector(selectOccupationCardsState, OccupationCardsState.selectAll);

// RETRIEVE OCCUPATION CARD COUNT
export const getRecommendedOccupationCategoriesCount: MemoizedSelector<
  object,
  number
> = createSelector(
  selectOccupationCardsState,
  (state): number => state.ids.length
);

// RETRIEVE LOADING
export const getLoading: MemoizedSelector<object, boolean> = createSelector(
  selectOccupationCardsState,
  (state) => state.loading
);

export const getOccupationCards: MemoizedSelector<object, IOccupationCard[]> =
  createSelector(selectOccupationCardsState, (state) => state.occupationCards);
